export const numerologyLocales = {
    en: {
        numerologies: {
            enkanitham: 'Tamil Numerology',
            chaldean: 'Chaldean Numerology',
            pythagorean: 'Pythagorean Numerology',
        },
    },
    ta: {
        numerologies: {
            enkanitham: 'தமிழ் எண்கணிதம்',
            chaldean: 'கல்தீய எண்கணிதம்',
            pythagorean: 'பித்தகோரஸ் எண்கணிதம்',
        },
    },
};
//# sourceMappingURL=Locales.js.map